export default __webpack_public_path__ + "static/Seeing-Both-c3f64209c3ed332bafbce814cc9cf4c8.png";